import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import {serviceGetClinic, serviceGetarea,serviceSmsTemplate} from  "../../Services/Service";
import { DateRangeComp } from '../DatePicker/CustomRangeDatePicker';
import format from 'date-fns/format';

export const RoleFilterComponent = ({onChange }) => (
  <>
    <div style={{ marginRight:"5px"}} >
        <select className="form-select form-select-sm" onChange={(e)=>onChange(e)} name="roleFilter">
            <option value="">Select role</option>
            <option value="admin">Admin</option>
            <option value="superadmin">Super Admin</option>
        </select>
    </div>  
  </>
);


export const ActiveInactiveFilterComponent = ({onChange }) => {
  return (
    <>
    <div style={{ marginRight:"5px"}} >
      <select className="form-select form-select-sm " onChange={(e)=>onChange(e)} name="activeInactiveFilter">
          <option value="">Select Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
      </select>
    </div>  
    </>
  );
}

export const PatientStatusFilterComponent = ({filterParam,onChange }) => {
  
  return (
    <>
      <div style={{ marginRight:"5px"}} >
          <select className="form-select form-select-sm" value={filterParam.statusFilter}  onChange={(e)=>onChange(e)} name="statusFilter">
              <option value="">--Select Status--</option>
              <option value="smsStatus:DELIVERED">Delivered</option>
              {/* <option value="smsStatus:FAILED">Failed</option> */}
              <option value="smsStatus:UNDELIVERED">Undelivered</option>
              <option value="smsSentDate:FOUND">SMS Sent</option>
              <option value="smsSentDate:NOTFOUND">SMS Notsent</option>
              <option value="loginDate:FOUND">Logged In</option>
              <option value="loginDate:NOTFOUND">Not Logged In</option>
              <option value="status:Active">Onboarded</option>
              <option value="status:Inactive">Not Onboarded</option>
          </select>
      </div> 
    </>
  );
}

export const PracticeFilterComponent = ({filterParam,onChange }) => {
  const [clinicData, setClinicData] = useState([]);
  useEffect(() => {
    loadClinicData();
},[]);
  const loadClinicData = async () =>{
      const response = await serviceGetClinic('');
      setClinicData(response.data.data.clinic);
  }
  return (
      <div style={{ marginRight:"5px"}} >
      {/* {customFilterDivision? */}
         <select className="form-select form-select-sm" value={filterParam.practiceFilter} onChange={(e)=>onChange(e)} name="practiceFilter">  
             <option value="">-- Select Practice --</option>
             {clinicData.map((data, i) => (
                 <option value={data.name} key={i}>{data.name}</option>
             ))}
         </select>
     </div>  
  );
}

export const DivisionFilterComponent = ({filterParam,onChange }) => {
  const [areaData, setAreaData] = useState([]);
  useEffect(() => {
      loadAreaData();
  },[]);
  const loadAreaData = async () =>{
      const response = await serviceGetarea('');
      setAreaData(response.data.data.area);
  }
  return (
      <div style={{ marginRight:"5px"}} >
         <select className="form-select form-select-sm" value={filterParam.divisionFilter}  onChange={(e)=>onChange(e)} name="divisionFilter">
             <option value="">-- Select Division --</option>
             {areaData.map((data, i) => (
                 <option value={data.areaName} key={i}>{data.areaName}</option>
             ))}
         </select>
     </div>  
  );
}
export const SmsDateFilterComponent = ({filterParam,onClick}) => {
  
  const [startRange, setStartRange] = useState('');
    const [endRange, setEndRange] = useState('');
    useEffect(() => {
      //loadAreaData();
  },[]);
  const getData = (data)=>{
    // console.log(data);
    let start = format(data[0].startDate,"yyyy-MM-dd");
    let end = format(data[0].endDate,"yyyy-MM-dd");      
    
    onClick(data);
  } 
  return (
    <div>
      <DateRangeComp typeofdate="blank" filterParam={filterParam} onClick={getData} /> 
    </div>
  );
}

export const MessageTemplate = (props) => {
  const [templateData, setTemplateData] = useState('');
  
  useEffect(() => {
    const loadTemplateData = async () => {
      try {
        const response = await serviceSmsTemplate(props.selectedValue);
        setTemplateData(response.data.data);
      } catch (error) {
        console.error('Error loading template data:', error);
      } 
    };

    loadTemplateData();
  }, [props.selectedValue]);

  return (
        <div style={{width: '100%', backgroundColor: '#e3dad2', maxHeight: '168px', border: '3px solid rgb(17, 21, 21)', padding: '10px',borderRadius: '20px', overflowY:"scroll"}}>
            <div>
            <div className="card">
                <div className="card-body px-3 py-2">
                    <p style={{fontSize:'12px', lineHeight:'1.3'}}>
                      {templateData}                      
                      <br/>
                    </p>
                    <p className='mt-1' style={{fontSize:'12px', fontWeight:'600', color:'#787878'}}>
                    #BETHEFORCE
                    </p>
                </div>
            </div>
            </div>
        </div>
  );
}

export const WhatsAppCheck = ({checkedItems,onChange}) => {
  
console.log(checkedItems)
  return (
    <div className='col-md-3 pe-0'>
      <div className="">
          <div className="px-3 pt-2 pb-3">
            <h6 className="mb-2">Select Communication Channel</h6>
            <div className="form-check-inline">
            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" checked={checkedItems.whatsApp} onChange={() => onChange('whatsApp')}/>
            <label className="form-check-label ps-2" htmlFor="inlineCheckbox1"> WhatsApp</label>
            </div>
            <div className="form-check-inline">
            <input className="form-check-input" type="checkbox" id="inlineCheckbox2" checked={checkedItems.sms} onChange={() => onChange('sms')}/>
            <label className="form-check-label ps-2" htmlFor='inlineCheckbox2'> SMS</label>
            </div>
          </div>
      </div>
    </div>
  );
}

export const CommunicationChannel = ({selectedValue,onChange}) => {

  return (
    <div className='col-md-5 pe-0'>
      <div className="">
          <div className="px-3 py-2">
                  <h6 className="mb-1">Select Communication Channel</h6>
                  <select  id="programSelect" name="programSelect" value={selectedValue} className='form-select form-select-sm' onChange={(e)=>onChange(e)} >
                      <option value="1">Reminder Message</option>
                      <option value="2">WhatsApp</option>
                      <option value="3">SMS</option>
                      <option value="4">Mail</option>
                  </select>
          </div>
        </div>
    </div>
  );
}